import { render, staticRenderFns } from "./TaskModuleRulesRuleDeleted.vue?vue&type=template&id=8e44e526&scoped=true"
import script from "./TaskModuleRulesRuleDeleted.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesRuleDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e44e526",
  null
  
)

export default component.exports